import { render, staticRenderFns } from "./misctab.vue.html?vue&type=template&id=31ccba8a&scoped=true"
import script from "./misctab.controller.ts?vue&type=script&lang=ts&external"
export * from "./misctab.controller.ts?vue&type=script&lang=ts&external"
import style0 from "./misctab.vue.html?vue&type=style&index=0&id=31ccba8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccba8a",
  null
  
)

export default component.exports